import attribs from '../../settings/references.json'

export { default as getTexts } from '../../store/localizer'

export const attributes = {
    languages: attribs.languages,
    apiPermissionsLink: attribs.link.apiPermissions,
}

export { default as Button } from '../../components/Button'
export { default as Tooltip } from '../../components/Tooltip'
export { launcherOpenCacheDialog, launcherOpenUrl } from '../../launcherBackend/launcher-command'



// WEBPACK FOOTER //
// ./src/features/Settings/imports.js